import type { AllowBlockState, PolicyRule } from '../types';

function sortedFieldKeys(fields: Record<string, string>): string[] {
  return Object.keys(fields).sort();
}

function ruleFieldsEqual(a: PolicyRule, b: PolicyRule): boolean {
  if (a.id !== b.id) {
    return false;
  }
  if (Boolean(a.pendingDelete) !== Boolean(b.pendingDelete)) {
    return false;
  }
  const keysA = sortedFieldKeys(a.fields);
  const keysB = sortedFieldKeys(b.fields);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (let i = 0; i < keysA.length; i++) {
    if (keysA[i] !== keysB[i]) {
      return false;
    }
  }
  for (const k of keysA) {
    if ((a.fields[k] ?? '') !== (b.fields[k] ?? '')) {
      return false;
    }
  }
  return true;
}

function ruleListsEqual(a: PolicyRule[], b: PolicyRule[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (!ruleFieldsEqual(a[i], b[i])) {
      return false;
    }
  }
  return true;
}

/** Stable comparison for allow/block form state (not JSON key-order sensitive). */
export function allowBlockStatesEqual(
  a: AllowBlockState,
  b: AllowBlockState
): boolean {
  if (a.blockedListMode !== b.blockedListMode) {
    return false;
  }
  return (
    ruleListsEqual(a.allowed, b.allowed) && ruleListsEqual(a.blocked, b.blocked)
  );
}
